import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 96.853 77.483',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      className="icon"
      d="M75.155,56.393l10.6-10.6a4.845,4.845,0,0,0-1.943-8.035L77.483,35.73v-21.2A4.843,4.843,0,0,0,72.64,9.685H62.955V3.632A3.632,3.632,0,0,0,59.323,0H37.531A3.632,3.632,0,0,0,33.9,3.632V9.685H24.213a4.843,4.843,0,0,0-4.843,4.843v21.2l-6.325,2.033A4.845,4.845,0,0,0,11.1,45.8l10.6,10.6C19.042,63,12.952,67.8,3.632,67.8A3.632,3.632,0,0,0,0,71.429v2.421a3.632,3.632,0,0,0,3.632,3.632c9.235,0,16.268-3.119,21.68-8.989a14.55,14.55,0,0,0,13.43,8.989H58.112a14.55,14.55,0,0,0,13.43-8.989c5.411,5.869,12.444,8.989,21.68,8.989a3.632,3.632,0,0,0,3.632-3.632V71.429A3.632,3.632,0,0,0,93.221,67.8C84.018,67.8,77.855,63.106,75.155,56.393Zm-46.1-37.022H67.8V32.617l-17.889-5.75a4.842,4.842,0,0,0-2.964,0l-17.889,5.75Z"
      fill={fill}
    />
  </svg>
);

export default SVG;
